import {
  message as staticMessage,
  notification as staticNotification,
} from "antd";

let apis = null;

export function setMessageApi(instances) {
  apis = instances;
}

export function getMessage() {
  return (apis && apis.message) || staticMessage;
}

export function getNotification() {
  return (apis && apis.notification) || staticNotification;
}
